export function getFullUrl(baseUrl, path) {
    if (!path) return "";
    if (/^(https?:|blob:)/i.test(path)) return path;
    return `${baseUrl.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
}

// convert absolute path to relative path
export const normalizeFilePath = (url) => {
    if (typeof url !== "string") return url;
    // Removes https://something.com/ part
    return url.replace(/^https?:\/\/[^/]+\//, "");
};
